"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusError = void 0;
var EventBusError = /** @class */ (function (_super) {
    __extends(EventBusError, _super);
    function EventBusError(errorType, message) {
        var _this = _super.call(this, message) || this;
        _this.errorType = errorType;
        return _this;
    }
    return EventBusError;
}(Error));
exports.EventBusError = EventBusError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/event-bus/errors/event-bus-error.js
// module id = 1186
// module chunks = 8